import JsZip from 'jszip';

/**
 * Consulta el contenido en objeto Blob de la url de un archivo
 * @param {String} url del archivo
 * @returns {Promise} contenido del archivo
 */
export async function blobDelArchivo(url) {
  const r = await fetch(url);
  if(r.ok) return r.blob();
  else alert('Error inesperado');
  return undefined;
}

/**
 * Clase que contiene los atributos necesarios 
 * para que la biblioteca jszip pueda comprimir archivos
 */
export class ArchivoParaComprimir {
  constructor(nombre, ruta) {
    this.nombre = nombre;
    this.ruta = ruta;
  }
}

/**
 * Conprime una lista de archivos y los devuelve como objeto Blob 
 * listo para descarga o manipular
 * @param {Array} archivosParaComprimir lista de clases ArchivoParaComprimir
 * @returns {Blob} de los archivos comprimidos
 */
export async function comprimirArchivos(archivosParaComprimir) {
  var zip = new JsZip();
  for (const archivo of archivosParaComprimir) {
    const blob = await blobDelArchivo(archivo.ruta);
    if (blob != undefined) zip.file(archivo.nombre, blob);
  }
  return await zip.generateAsync({type: 'blob'});
}

/**
 * Crea, ejecuta y destruye el enlace temporal de descarga
 * @param {String} nombre Nombre del archivo con extención
 * @param {*} evt Contenido de la descarga en objeto Blob
 */
function enlaceDescarga(nombre, evt) {
  var link = document.createElement('a');
  link.href = evt.target.result;
  link.target = '_blank';
  link.download = nombre;
  //link.dispatchEvent(clickSimulado);
  link.click();

  (window.URL || window.webkitURL).revokeObjectURL(link.href);
};

/**
 * Prepara la lectura y descarga del contenido
 * @param {String} nombre Nombre del archivo
 * @param {Blob} contenido Contenido de la descarga en objeto Blob
 */
export function descargarArchivo(nombre, contenido) {
  var lector = new FileReader();
  lector.onload = (evt) => {
    enlaceDescarga(`${nombre}`, evt);
  };
  lector.readAsDataURL(contenido);
};